import React from 'react';

const Copyright: React.FC = () => (
  <>
    ©GAQSA | Derechos Reservados
  </>
);

export default Copyright;
